import React from 'react';
import PropTypes from 'prop-types';
import { CustomerCalculatedSubscriptionStateEnum } from '@src/graphql/generated';
import { NextPaymentDateStatus } from '../NextPaymentDateStatus';
import LockedStatusMessage from '../LockedStatusMessage';
import './styles.scss';

const { TRIAL_ACTIVE } = CustomerCalculatedSubscriptionStateEnum;

export default function SubscribedTrialNotEnded({ trialEndsAt }) {
  return (
    <div className="subscribed-trial-not-ended">
      <LockedStatusMessage state={TRIAL_ACTIVE} trialEndsAt={trialEndsAt} />

      <div className="subscribed-trial-not-ended__wrapper">
        <NextPaymentDateStatus label="First payment date" nextPaymentDate={trialEndsAt} />
      </div>
    </div>
  );
}

SubscribedTrialNotEnded.propTypes = {
  trialEndsAt: PropTypes.string.isRequired,
};
